import reportWebVitals from "./reportWebVitals";
import "./theme.css";
import "react-datepicker/dist/react-datepicker.css";
import 'react-dual-listbox/lib/react-dual-listbox.css';
import ReactDOM from "react-dom/client";
import WebRoutes from "./routes/route";
import store from "./Store/store";
import { Provider } from "react-redux";
import Loader from "./components/commonComponents/Loader";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/theme";

import withClearCache from "./clearCache";
import { usePostHog } from "./hooks/usePostHog";
import CookieBanner from "./components/commonComponents/CookieBanner/CookieBanner";
import { initializeConsent } from "./utils/cookieUtils";

initializeConsent();

function MainApp(props) {
  usePostHog();

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <WebRoutes />
        <Loader />
        <ToastContainer position="top-right" autoClose={5000} theme="light" />
        <CookieBanner />
      </ThemeProvider>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const ClearCacheComponent = withClearCache(MainApp);

root.render(
  <ClearCacheComponent />
);

reportWebVitals();